import * as actionTypes from "../actions/actionTypes";

export const initialInsurance = {
  insured_plan_name: "",
  insurance_carrier_id: "",
  insurance_type: "",
  insured_id_number: "",
  insured_group: "",
  insured_patient_relation: "",
  ins_plan_name: "",
  insured_first_name: "",
  insured_last_name: "",
  insured_middle_name: "",
  insured_dob: null,
  insured_gender: "",
  insured_address1: "",
  insured_state_cd: "",
  insured_city: "",
  insured_zip: "",
  insured_phone_no_mobile: "",
  insured_phone_no_home: "",
  insured_phone_no_work: "",
  another_plan: "",
  medicare_secondary_reason_cd: "",
  // Data not on UI
  insured_address2: "",
  insured_country: "",
  insured_employer: "",
};
export const initialState = {
  patient_details: {
    patient_id: null,
    claims_id: null,
    claim_status: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    dob: "",
    email: "",
    gender: "",
    address1: "",
    address2: "",
    city: "",
    state_cd: "",
    country: "",
    zip: "",
    phone_no_mobile: "",
    phone_no_home: "",
    phone_no_work: "",
    height: "",
    weight: "",
    blood_group: "",
  },
  patient_charge_entry: {
    billing_provider_id: null,
    charge_entry_auth_id: null,
    charge_entry_id: null,
    encounter_id: null,
    insurance_id: null,
    notes_id: null,
    patient_id: null,
    payer_id: null,
    primary_payer_id: null,
    provider_id: null,
    ref_provider_id: null,
    secondary_payer_id: null,
    status: "",
  },
  insurance: { ...initialInsurance },
  illness: {
    current_illness_date: null,
    auto_accident: "",
    other_accident: "",
    ref_num: "",
    outside_lab: "",
    resubmission_code: "",
    employement_related: "",
    auto_accident_state: "",
    unable_to_work_from: null,
    unable_to_work_to: null,
    hospitalization_date_from: null,
    hospitalization_date_to: null,
    ref_prov_title: "",
    ref_prov_firstname: "",
    ref_prov_lastname: "",
    ref_prov_phone: "",
    ref_prov_npi: "",
    diagnosis1: "",
    diagnosis2: "",
    diagnosis3: "",
    diagnosis4: "",
    diagnosis5: "",
    diagnosis6: "",
    diagnosis7: "",
    diagnosis8: "",
    diagnosis9: "",
    diagnosis10: "",
    diagnosis11: "",
    diagnosis12: "",
  },
  notes: {
    notes: "",
    signature: "",
    signature_date: null,

    chief_complaint: "",
    present_illness_history: "",
    current_meds: "",
    active_problems: "",
    social_history: "",
    plan: "",
    summary: "",
    allergies: "",
    system_review: "",
    family_history: "",
    surgical_history: "",
    physical_exam: "",
    impression: "",
    imaging_studies: "",
    recommendation: "",
    vitals: [],
  },
  charges: [],
  documents: [],
  procedure_cost: {},
  // to avoid repeating get calls
  fetched_illness: false,
  fetched_charges: false,
  fetched_notes: false,
  fetched_documents: false,
  facilityClaimData: {},
};

const reducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case actionTypes.GET_DOCUMENTS:
      return {
        ...state,
        fetched_documents: true,
        documents: action.docs,
      };
    case actionTypes.GET_ILLNESS:
      return {
        ...state,
        fetched_illness: true,
        illness: {
          ...state.illness,
          ...action.illness,
        },
      };
    // case actionTypes.UPDATE_ILLNESS:
    //     return {
    //         ...state,
    //         illness: {
    //             ...state.illness,
    //             ...action.data
    //         }
    //     };
    case actionTypes.FACILITY_CLAIMS: {
      const { fieldName, id } = action.payload;
      if (fieldName) {
        const existingFields = state.facilityClaimData[fieldName] || [];
        const existingIndex = existingFields.findIndex(
          (item) => item.id === id
        );

        let updatedFields;
        if (existingIndex !== -1) {
          // If the field is found, replace the existing field at the found index
          updatedFields = [
            ...existingFields.slice(0, existingIndex),
            action.payload,
            ...existingFields.slice(existingIndex + 1),
          ];
        } else {
          // If not found, add the new field
          updatedFields = [...existingFields, action.payload];
        }

        return {
          ...state,
          facilityClaimData: {
            ...state.facilityClaimData,
            [fieldName]: updatedFields,
          },
        };
      }
      return state;
    }
    case actionTypes.GET_INSURANCE:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          ...action.insurance,
        },
      };
    case actionTypes.GET_NOTES:
      return {
        ...state,
        fetched_notes: true,
        notes: { ...action.auth, ...action.notes },
      };
    case actionTypes.GET_CHARGES:
      return {
        ...state,
        fetched_charges: true,
        charges: action.charges,
      };
    case actionTypes.UPDATE_CHARGES:
      return {
        ...state,
        charges: action.charges,
      };
    case actionTypes.SET_PATIENT:
      return {
        ...state,
        patient_details: {
          ...state.patient_details,
          ...action.details,
        },
      };
    case actionTypes.RESET_CHARGE_ENTRY:
      return {
        ...state,
        insurance: initialState.insurance,
        illness: initialState.illness,
        notes: initialState.notes,
        patient_charge_entry: initialState.patient_charge_entry,
        charges: initialState.charges,
        costs: initialState.costs,
      };
    case actionTypes.SET_PATIENT_CHARGE_ENTRY:
      return {
        ...state,
        patient_charge_entry: action.details,
      };
    case actionTypes.UPDATE_CLAIMS_ID:
      return {
        ...state,
        patient_charge_entry: {
          ...state.patient_charge_entry,
          ...action.claim_ids,
        },
      };
    case actionTypes.SET_PROCEDURE_COST:
      return {
        ...state,
        procedure_cost: action.procedure_cost,
      };
    case actionTypes.SET_PATIENT_INS_LIST:
      return {
        ...state,
        insurance_list: action.insurance_list,
      };
    case actionTypes.CLEAR_INSURANCE:
      return {
        ...state,
        insurance: initialState.insurance,
      };
    case actionTypes.UPDATE_INSURANCE:
      return {
        ...state,
        patient_charge_entry: {
          ...state.patient_charge_entry,
          insurance_id_primary: action.primary,
          insurance_id_secondary: action.secondary,
          insurance_id_tertiary: action.tertiary,
        },
      };
    case actionTypes.CLEAR_CHARGE_ENTRY: {
      return { ...initialState };
    }
    default:
      return state;
  }
};

export default reducer;
